const PRODUCT_LIST_STEP = 'productList';
const REVIEW_AND_SUBMIT_STEP = 'reviewAndSubmit';

const FLOW_STEPS = {
  productList: PRODUCT_LIST_STEP,
  reviewAndSubmit: REVIEW_AND_SUBMIT_STEP
};

export { FLOW_STEPS };
